import { useEffect, useState } from 'react';

import { getOpenInvoices } from '../../../api';
import { logError } from '../../../logging/loggingService';

export default function useOpenInvoices(appliedFilters) {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        (async () => {
            try {
                const res = await getOpenInvoices(appliedFilters);
                if (cancelled) return;
                setInvoices(Array.isArray(res?.data) ? res.data : []);
            } catch (err) {
                if (!cancelled) {
                    logError('Failed to load open invoices', err);
                    setError('Die offenen Posten konnten nicht geladen werden.');
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [appliedFilters]);

    return { invoices, loading, error };
}
